export default __webpack_public_path__ + "static/media/amad1.cdf761b2.png";